export const alwaysFalse = (): boolean => false;
